import http, {makeSearchParams} from 'utils/http';

export const getStandardsBodyRelated = (queries) => {
  return http('GET', `/standards/body-related`, makeSearchParams(queries));
};

export const getStandardsCertsFilter = (queries) => {
  return http('GET', `/standards/certs-filter`, queries);
};

export const getStandards = (queries) => {
  return http('GET', `/standards/list`, makeSearchParams(queries));
};

// Get Public Standard use in CB Search

export const getPublicStandards = (queries) => {
  return http('GET', `/g/standards/search-by-name`, makeSearchParams(queries));
};

export const getTopCountriesByStandard = (queries) => {
  return http('GET', `/g/country/top-countries-by-standard`, queries);
};
